<ion-header class="ion-no-border" translucent="false">
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button (click)="modalCtrl.dismiss({action: 'regular-close'})">
        <ion-icon color="dark" slot="icon-only" name="close-circle"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>Pick Emoji</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <app-emoji-picker [message]="message" [type]="type"></app-emoji-picker>
</ion-content>
